import { Component, OnInit, Inject } from '@angular/core';
import { PageComponent, ICC_PAGE_DATA } from '@icc/configurator/shared';
import { _, SharedFacade } from '@icc/configurator/shared';
import { iccListItem } from '@icc/configurator/ui';

@Component({
    selector: 'icc-awning-styles-page',
    templateUrl: './awning-styles-page.component.html',
    styleUrls: ['./awning-styles-page.component.scss'],
    standalone: false
})
export class AwningStylesPageComponent extends PageComponent implements OnInit {
    public title = _('AWNING|Wybierz styl poszycia');

    styles: iccListItem[] = [];
    selectedStyleId: number | null = null;

    constructor(
        private sharedFacade: SharedFacade,
        @Inject(ICC_PAGE_DATA)
        private pageData: {
            styles: any[];
        }
    ) {
        super();
    }

    ngOnInit() {
        this.styles = this.pageData.styles.map<iccListItem>(style => ({
            id: Number(style.id),
            title: style.title,
            imageUrl: '/files/awningfabricstyle/' + style.img,
        }));
    }

    selectStyle(item: iccListItem) {
        const style = this.pageData.styles.find(
            s => Number(item.id) === Number(s.id)
        );
        if (style) {
            this.sharedFacade.closePage([style]);
        }
    }
}
